import { Icon12Stars, Icon16Stars } from '@vkontakte/icons';
import { Button, classNames, Spacing } from '@vkontakte/vkui';
import { HoverPopper } from '@vkontakte/vkui/dist/components/HoverPopper/HoverPopper';
import Lottie from 'lottie-react';
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import type { EStorageType } from 'reactApp/modules/storage/storage.types';
import { renderAiGenerateAndEditFakedoorModal } from 'reactApp/ui/AiGenerateAndEditFakedoor/AiGenerateAndEditFakedoorModal';
import { markFakedoorIsCompleteByTooltips } from 'reactApp/utils/aiGenerateAndEditFakedoor';
import { sendDwh, sendXray } from 'reactApp/utils/ga';

import styles from './AiTooltipForMediaFiles.css';
import animation from './animation.json';

interface AiTooltipForMediaFilesProps {
    size?: 20 | 24 | 28 | 32;
    hasBorder?: boolean;
    useLottieAnimation?: boolean;
}

const sendRadar = (action: 'show' | 'click' | 'close', place: EStorageType, isViewer: boolean) => {
    const ctrl = isViewer ? 'button' : 'tooltip';
    sendXray([`ai-fakedoor-${ctrl}`, action]);
    sendDwh({
        eventCategory: ctrl,
        action,
        dwhData: { name: 'fakedoor_generate_edit_media_cool', place },
    });
};

const aiIconClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
};

const onButtonClickHandler = (e: React.MouseEvent, place: EStorageType, isViewer: boolean) => {
    e.stopPropagation();
    sendRadar('click', place, isViewer);
    renderAiGenerateAndEditFakedoorModal({
        onComplete: markFakedoorIsCompleteByTooltips,
    });
};

export const AiTooltipForMediaFiles: React.FC<AiTooltipForMediaFilesProps> = ({ size, hasBorder, useLottieAnimation }) => {
    const storage = useSelector(getCurrentStorage);

    useEffect(() => {
        if (useLottieAnimation) {
            sendRadar('show', storage, true);
        }
    }, []);

    if (useLottieAnimation) {
        return (
            <Lottie
                animationData={animation}
                autoplay
                loop
                onClick={(e) => {
                    onButtonClickHandler(e, storage, true);
                }}
                className={styles.lottie}
            />
        );
    }

    return (
        <HoverPopper
            arrow
            arrowClassName={styles.arrow}
            content={
                <div className={styles.tooltip}>
                    <span className={styles.title}>С&nbsp;нейросетью качество фото можно улучшить</span>
                    <Spacing size={4} />
                    <span>Подправит резкость, очистит фон, а&nbsp;эмоции сохранит настоящими</span>
                    <Spacing size={12} />
                    <Button
                        size="l"
                        mode="primary"
                        appearance="accent"
                        className={styles.button}
                        onClick={(e) => {
                            onButtonClickHandler(e, storage, false);
                        }}
                    >
                        Узнать больше
                    </Button>
                </div>
            }
            onShownChange={(shown) => {
                sendRadar(shown ? 'show' : 'close', storage, false);
            }}
        >
            <div
                className={classNames(styles.aiIcon, {
                    [styles.aiIcon24]: size === 24,
                    [styles.aiIcon28]: size === 28,
                    [styles.aiIcon32]: size === 32,
                    [styles.aiIconBorder]: hasBorder,
                })}
                onClick={aiIconClickHandler}
            >
                {size === 32 || size === 28 ? (
                    <Icon16Stars fill="var(--vkui--color_text_contrast)" />
                ) : (
                    <Icon12Stars fill="var(--vkui--color_text_contrast)" />
                )}
            </div>
        </HoverPopper>
    );
};
